// export const initFetch = (url: string, endpoints?: any[], options?: any) => {
//   const BASE_URL = url;
//   return fetch(BASE_URL, options);
// };
import Cookies from "js-cookie";
// type Response<T> = T extends T ? T : unknown;
async function api(url, options) {
    const response = await fetch(url, options)
        .then((response) => {
        const body = response.json();
        return body;
    })
        .catch((error) => {
        return error; // ? it should be thrown
    });
    return response;
}
export const signIn = (url, loginField, passwordField) => {
    const options = {
        method: "POST",
        body: JSON.stringify({
            [loginField.propName]: loginField.value,
            [passwordField.propName]: passwordField.value,
        }),
        headers: {
            "Content-Type": "application/json",
        },
    };
    return api(url, options);
};
export const signOut = (url) => {
    const accessToken = Cookies.get("accessToken");
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    };
    if (accessToken) {
        options.headers["X-Auth-Token"] = accessToken;
    }
    return api(url, options);
};
export const refresh = (url, refreshToken) => {
    const accessToken = Cookies.get("accessToken");
    const options = {
        method: "POST",
        body: JSON.stringify({
            refreshToken,
        }),
        headers: {
            "Content-Type": "application/json",
        },
    };
    if (accessToken) {
        options.headers["X-Auth-Token"] = accessToken;
    }
    return api(url, options);
};
//# sourceMappingURL=api.js.map